"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var Progress = function Progress(_a) {
  var _b;

  var children = _a.children,
      className = _a.className,
      isAnimated = _a.isAnimated,
      isStriped = _a.isStriped,
      _c = _a.theme,
      theme = _c === void 0 ? 'primary' : _c,
      _d = _a.size,
      size = _d === void 0 ? 'md' : _d,
      _e = _a.value,
      value = _e === void 0 ? 0 : _e,
      other = __rest(_a, ["children", "className", "isAnimated", "isStriped", "theme", "size", "value"]);

  var classes = classnames_1.default(className, 'progress');
  var barClasses = classnames_1.default('progress-bar', (_b = {}, _b["bg-" + theme] = theme && value <= 100, _b), {
    'bg-danger': value > 100
  }, {
    'progress-bar-animated': isAnimated
  }, {
    'progress-bar-striped': isStriped
  });
  return React.createElement("div", __assign({}, other, {
    className: classes,
    "data-test-id": "progress",
    style: {
      height: "" + (size === 'sm' ? '0.5rem' : size === 'lg' ? '1.5rem' : '1rem'),
      fontSize: "" + (size === 'sm' ? '0.5rem' : size === 'lg' ? '1rem' : '0.75rem')
    }
  }), React.createElement("div", {
    className: barClasses,
    "data-test-id": "progress-bar",
    role: "progressbar",
    style: {
      width: value + "%"
    },
    "aria-valuenow": value,
    "aria-valuemin": 0,
    "aria-valuemax": 100
  }, children));
};

exports.default = Progress;